import axios from "axios";
import type { PageSpeedResponse } from "../types/analyzer";

const PAGE_SPEED_ENDPOINT = "https://www.googleapis.com/pagespeedonline/v5/runPagespeed";

const PAGE_SPEED_API_KEY =
	process.env.REACT_APP_PAGESPEED_API_KEY ??
	"AIzaSyCy0UofVMq-_XySam0x3wJLD5XyYX4OiSY";

export const fetchPageSpeed = async (url: string): Promise<PageSpeedResponse> => {
	const endpoint = new URL(PAGE_SPEED_ENDPOINT);
	endpoint.searchParams.set("category", "ACCESSIBILITY");
	endpoint.searchParams.append("category", "BEST_PRACTICES");
	endpoint.searchParams.append("category", "PERFORMANCE");
	endpoint.searchParams.append("category", "PWA");
	endpoint.searchParams.append("category", "SEO");
	endpoint.searchParams.set("url", `https://${url}`);
	endpoint.searchParams.set("key", PAGE_SPEED_API_KEY);

	const { data } = await axios.get<PageSpeedResponse>(endpoint.toString());
	return data;
};